module.exports = __webpack_public_path__ + "static/quickres_icon-9a247f456756d8edfe4c41f45737cba7.png";